export default "__VITE_ASSET__x$C2OOZQ__"